export enum PbhRequestFileType {
  None = 0,
  Serviceable = 1,
  Unserviceable = 2,
  Info = 3,
  Awb = 4,
  FormOne = 5,
  ShippingInvoice = 6,
  ShopReport = 7,
  Pod = 8,
  Warranty = 9,
  Other = 10,
  WaitingPoolScopeList = 21,
  FormOneShopReport = 11,
  ShippingInvoiceAwb = 12,
  Cid = 13,
  UsTag = 14,
  Mailings = 15,
  Defect = 16,
  ManualUpdate = 17,
  UnusedStatement = 18,
  PartPhoto = 19,
  TsnAndCsnStatement = 22,
  PnAndSnStatement = 23,
  MaintenanceRecord = 24,
  BackToBirth = 25,
}

export const GetPbhRequestFileGroupType = [
  { Description: "Serviceable", Value: PbhRequestFileType.Serviceable },
  { Description: "Core Unit", Value: PbhRequestFileType.Unserviceable },
  { Description: "Info", Value: PbhRequestFileType.Info },
];

export const GetPbhRequestServiceableFileType = [
  { Description: "Shipping Invoice", Value: PbhRequestFileType.ShippingInvoice },
  { Description: "Awb", Value: PbhRequestFileType.Awb },
  { Description: "Form One", Value: PbhRequestFileType.FormOne },
  { Description: "Shop Report", Value: PbhRequestFileType.ShopReport },
  { Description: "POD", Value: PbhRequestFileType.Pod },
  { Description: "Warranty", Value: PbhRequestFileType.Warranty },
  { Description: "Other", Value: PbhRequestFileType.Other },
  { Description: "Form One & Shop Report", Value: PbhRequestFileType.FormOneShopReport },
  { Description: "Shipping Invoice & Awb", Value: PbhRequestFileType.ShippingInvoiceAwb },
  { Description: "Cid", Value: PbhRequestFileType.Cid },
  { Description: "US TAG", Value: PbhRequestFileType.UsTag },
  { Description: "Mailings", Value: PbhRequestFileType.Mailings },
  { Description: "Unused Statement", Value: PbhRequestFileType.UnusedStatement },
  { Description: "Part Photo", Value: PbhRequestFileType.PartPhoto },
  { Description: "TSN & CSN Statement", Value: PbhRequestFileType.TsnAndCsnStatement },
  { Description: "PN & SN Statement", Value: PbhRequestFileType.PnAndSnStatement },
  { Description: "Maintenance Record", Value: PbhRequestFileType.MaintenanceRecord },
  { Description: "Back To Birth", Value: PbhRequestFileType.BackToBirth },
];
